module.exports = __webpack_public_path__ + "static/media/3_5_aubrey_flynn.79b5cfd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/3_5_aubrey_flynn.mp3
// module id = j8nd
// module chunks = 1